import { render } from "./ImportCustomer.vue?vue&type=template&id=30894e96&scoped=true"
import script from "./ImportCustomer.vue?vue&type=script&lang=js"
export * from "./ImportCustomer.vue?vue&type=script&lang=js"

import "../item/importShared.css?vue&type=style&index=0&id=30894e96&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30894e96"]])

export default __exports__